import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "../../config/firebase";

export const useStaffMember = (staffId) => {
  const staffDocRef = staffId ? doc(db, "staff", staffId) : null;
  const [staffMember, loading, error] = useDocumentData(staffDocRef);

  return {
    staffMember,
    loading,
    error,
  };
};

export default useStaffMember;
